module.exports = __webpack_public_path__ + "img/weibotGrey.a1900551.svg";